module.exports = __webpack_public_path__ + "static/media/GW.31ab457c.png";